import React, { useState } from "react";
import styled from "styled-components";

const bugGrey = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_bug_grey.svg";
const bugPink = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_bug_pink.svg";
const dollarGrey = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_dollar_grey.svg";
const dollarPink = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_dollar_pink.svg";
const hammerGrey = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_hammer_grey.svg";
const hammerPink = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_hammer_pink.svg";
const personGrey = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_person_grey.svg";
const personPink = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_person_pink.svg";
const planeGrey = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_plane_grey.svg";
const planePink = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_plane_pink.svg";
const shieldGrey = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_shield_grey.svg";
const shieldPink = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_shield_pink.svg";
const timeGrey = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_time_grey.svg";
const timePink = "https://d3bb2njoyzhxtr.cloudfront.net/static/landing_icon_time_pink.svg";

const categories = [
    {
        key: "scammers",
        label: "Fight Scammers",
        iconGrey: bugGrey,
        iconPink: bugPink,
    },
    {
        key: "bureaucracy",
        label: "Beat Bureaucracy",
        iconGrey: hammerGrey,
        iconPink: hammerPink,
    },
    {
        key: "freeMoney",
        label: "Find Free Money",
        iconGrey: dollarGrey,
        iconPink: dollarPink,
    },
    {
        key: "privacy",
        label: "Protect Privacy",
        iconGrey: shieldGrey,
        iconPink: shieldPink,
    },
    {
        key: "saveTime",
        label: "Save Time",
        iconGrey: timeGrey,
        iconPink: timePink,
    },
    {
        key: "travel",
        label: "Travel & Transportation",
        iconGrey: planeGrey,
        iconPink: planePink,
    },
    {
        key: "consumerRights",
        label: "Consumer Rights",
        iconGrey: personGrey,
        iconPink: personPink,
    },
];

const postsByCategory = {
    freeMoney: [
        {
            title: "Use a Virtual Credit Card for Free Trials",
            date: "July 27, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/free_money_card_1.png",
            link: "virtual-credit-cards",
        },
        {
            title: "Free Virtual Credit Card Generator",
            date: "July 2, 2025",
            read: "3 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/free_money_card_6.png",
            link: "virtual-credit-card-generator",
        },
        {
            title: "DoNotPay's Free Trial Credit Card",
            date: "July 10, 2025",
            read: "5 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/free_money_card_2.png",
            link: "free-trial-credit-card",
        },
        {
            title: "How to Start an HBO Max Free Trial",
            date: "July 15, 2025",
            read: "6 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/free_money_card_3.png",
            link: "hbo-free-trial",
        },
        {
            title: "How To Seize the Tinder Gold Free Trial",
            date: "July 20, 2025",
            read: "2 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/free_money_card_4.png",
            link: "tinder-gold-free-trial",
        },
        {
            title: "Smart Hack That'll Get You a PlayStation Plus Free Trial",
            date: "July 25, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/free_money_card_5.png",
            link: "playstation-plus-free-trial",
        },
    ],
    bureaucracy: [
        {
            title: "Best Grants to Help Pay Bills",
            date: "July 27, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/beat_bureaucracy_1.png",
            link: "grants-to-help-pay-bills",
        },
        {
            title: "Dispute Parking Citations in New York City, NY",
            date: "July 2, 2025",
            read: "3 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/beat_bureaucracy_2.png",
            link: "dispute-nyc-parking-tickets",
        },
        {
            title: "Contest California Parking Tickets",
            date: "July 10, 2025",
            read: "5 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/beat_bureaucracy_3.png",
            link: "california-parking-tickets",
        },
        {
            title: "How To Send Inmate Text Messages",
            date: "July 15, 2025",
            read: "6 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/beat_bureaucracy_4.png",
            link: "inmate-text-messages",
        },
        {
            title: "How To Do Unclaimed Money Search by Social Security Number",
            date: "July 20, 2025",
            read: "2 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/beat_bureaucracy_5.png",
            link: "unclaimed-money-search-by-social-security-number",
        },
        {
            title: "How to Skip the Line for DMV Appointments in Florida",
            date: "July 25, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/beat_bureaucracy_6.png",
            link: "florida-dmv-appointment",
        },
    ],
    scammers: [
        {
            title: "How to Get a Zelle Chargeback",
            date: "July 27, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/fight_scammers_1.svg",
            link: "zelle-chargeback",
        },
        {
            title: "How to Request a Vanilla Gift Card Refund",
            date: "July 2, 2025",
            read: "3 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/fight_scammers_6.png",
            link: "vanilla-gift-card-refund",
        },
        {
            title: "How to Request a Cash App Refund and Get It",
            date: "July 10, 2025",
            read: "5 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/fight_scammers_2.png",
            link: "cash-app-refund",
        },
        {
            title: "Learn How To Report Robocalls",
            date: "July 15, 2025",
            read: "6 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/fight_scammers_4.png",
            link: "report-robocall",
        },
        {
            title: "How to Make Money Off Robocalls & Get Compensation",
            date: "July 20, 2025",
            read: "2 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/fight_scammers_3.svg",
            link: "make-money-off-robocalls",
        },
        {
            title: "How to Get Money Back from PayPal",
            date: "July 25, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/fight_scammers_5.png",
            link: "how-to-get-money-back-from-paypal",
        },
    ],
    privacy: [
        {
            title: "Use a Temporary Phone Number To Protect Your Privacy",
            date: "July 27, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/protect_privacy_1.png",
            link: "temporary-phone-number",
        },
        {
            title: "Tinder Phone Number Verification Explained",
            date: "July 2, 2025",
            read: "3 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/protect_privacy_2.png",
            link: "tinder-phone-number-verification",
        },
        {
            title: "Easy Non-VoIP Phone Number for Verification",
            date: "July 10, 2025",
            read: "5 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/protect_privacy_3.png",
            link: "non-voip-phone-number-for-verification",
        },
        {
            title: "How to Find and Use a Fake Phone Number — 4 Easy Steps",
            date: "July 15, 2025",
            read: "6 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/protect_privacy_4.png",
            link: "fake-phone-number",
        },
        {
            title: "Breakdown of the Discord Phone Verification Bypass",
            date: "July 20, 2025",
            read: "2 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/protect_privacy_5.svg",
            link: "discord-phone-verification-bypass",
        },
        {
            title: "Create a Gmail Account Without Phone Number Verification",
            date: "July 25, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/protect_privacy_6.png",
            link: "create-gmail-account-without-phone-verification",
        },
    ],
    saveTime: [
        {
            title: "Canceling Planet Fitness Membership",
            date: "July 27, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/save_time_1.png",
            link: "cancel-planet-fitness",
        },
        {
            title: "Cancel YourScoreandMore Subscription Fast",
            date: "July 2, 2025",
            read: "3 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/save_time_2.png",
            link: "cancel-yourscoreandmore",
        },
        {
            title: "How to Get a DoorDash Refund",
            date: "July 10, 2025",
            read: "5 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/save_time_3.png",
            link: "doordash-refund",
        },
        {
            title: "Banned From Snapchat? Here's Why It Happened and How To Reverse It",
            date: "July 15, 2025",
            read: "6 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/save_time_4.png",
            link: "banned-from-snapchat",
        },
        {
            title: "Can You Get a Grammarly Refund? — Yes, Here's How!",
            date: "July 20, 2025",
            read: "2 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/save_time_5.png",
            link: "grammarly-refund",
        },
        {
            title: "Can I Appeal My Suspension? All the Information You Need",
            date: "July 25, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/save_time_6.png",
            link: "can-i-appeal-my-suspension",
        },
    ],
    travel: [
        {
            title: "Claim Compensation For Poor Southwest WiFi",
            date: "July 27, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/travel_and_transportation_1.png",
            link: "southwest-airlines-wifi",
        },
        {
            title: "Does American Airlines offer Wifi Services?",
            date: "July 2, 2025",
            read: "3 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/travel_and_transportation_2.png",
            link: "american-airlines-wifi",
        },
        {
            title: "Claim Compensation for Delayed Flights",
            date: "July 10, 2025",
            read: "5 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/travel_and_transportation_3.png",
            link: "flight-delay-compensation",
        },
        {
            title: "Claim Compensations for Canceled Flights",
            date: "July 15, 2025",
            read: "6 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/travel_and_transportation_4.png",
            link: "flights-cancelled",
        },
        {
            title: "Claim United Airlines Compensation",
            date: "July 20, 2025",
            read: "2 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/travel_and_transportation_5.png",
            link: "united-airlines-compensation",
        },
        {
            title: "Get Compensation for Delta Airlines Delayed Flights",
            date: "July 25, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/travel_and_transportation_6.png",
            link: "delta-flight-delays",
        },
    ],
    consumerRights: [
        {
            title: "All You Need to Know About the Section 8 Housing Voucher Program",
            date: "July 1, 2025",
            read: "5 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/consumer_rights_1.png",
            link: "section-8-vouchers",
        },
        {
            title: "Learn How To File a Warranty Claim",
            date: "July 8, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/consumer_rights_2.png",
            link: "warranty-claim",
        },
        {
            title: "Here's How to Get Your Money Back for an Internet Outage",
            date: "July 15, 2025",
            read: "6 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/consumer_rights_3.png",
            link: "internet-outage",
        },
        {
            title: "What Party Am I Registered to Vote As?",
            date: "July 22, 2025",
            read: "3 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/consumer_rights_5.png",
            link: "what-party-am-i-registered-to-vote-as",
        },
        {
            title: "The Ins and Outs of a Sex Offenders Map",
            date: "July 29, 2025",
            read: "7 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/consumer_rights_4.png",
            link: "sex-offenders-map",
        },
        {
            title: "How to Request a Credit Limit Increase — and Get It",
            date: "July 5, 2025",
            read: "4 min read",
            image: "https://d3bb2njoyzhxtr.cloudfront.net/static/consumer_rights_6.png",
            link: "how-to-increase-credit-limit",
        },
    ],
};

const SelectionBarSection = styled.section`
  background: #fff;
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;
  padding-top: 0;
  padding-bottom: 0;
`;

const SelectionBar = styled.div`
  display: flex;
  align-items: stretch;
  height: 68px;
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  margin: 145px 0 0 0;
  padding: 0;
  background: rgba(161, 161, 177, 0.14);

  > button {
    flex: 1 0 auto;
    min-width: 0;
    max-width: 100%;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const SelectionItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background: ${({ selected }) => (selected ? "#fff" : "transparent")};
  color: ${({ selected }) => (selected ? "#2D0F29" : "#757285")};
  font-size: 0.85rem;
  font-weight: 600;
  border: none;
  outline: none;
  cursor: pointer;
  margin: 2px;
  padding: 0 10px;
  height: 64px;
  border-radius: 10px;
  transition: background 0.15s, color 0.15s;
  box-shadow: ${({ selected }) => (selected ? "0 2px 8px 0 rgba(60,60,90,0.07)" : "none")};
  white-space: normal;
  text-align: center; 
  word-break: break-word;

  &:hover {
    background: #f5f5f6;
    color: #2D0F29;
  }
`;

const SelectionIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  display: block;
`;

const PostsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  max-width: 1250px;
  margin: 32px 0;
  background: #fff;

  @media (max-width: 1264px) {
    justify-content: center;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const PostsGridMobile = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  width: 100%;
  max-width: 1250px;
  margin: 0 0;
  background: #fff;

  @media (max-width: 900px) {
    display: flex;
  }
`;

const PostItem = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border-radius: 12px;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  padding: 5px;
  max-width: 390px;

  @media (max-width: 900px) {
    width: 80%;
    max-width: 400px;
  }
`;

const PostImage = styled.img`
  width: 100%;
  height: 220px;
  max-width: 400px;
  object-fit: cover;
  background: transparent;
  border-radius: 12px;
  
  box-shadow: 0 2px 12px 0 rgba(60,60,90,0.16), 0 1.5px 4px 0 rgba(60,60,90,0.07);
  margin: 10px;
  margin-bottom: 12px;
  transition: transform 0.2s, box-shadow 0.2s;
   &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 16px 0 rgba(60,60,90,0.16), 0 2px 8px 0 rgba(60,60,90, 0.25)
  }

  @media (max-width: 900px) {
    height: auto;
    max-width: 100%;
  }
`;

const PostTitle = styled.div`
  color: #2D0F29;
  font-size: 1.18rem;
  font-weight: 700;
  margin: 0 0 6px 0;
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
  height: auto;
  max-height: 3.2em;
  max-width: 400px;
  padding: 0 10px;
`;

const PostMeta = styled.div`
  color: #757285;
  font-size: 1.01rem;
  font-weight: 500;
  padding: 0 10px;
  width: 100%;
  
  .number {
    font-weight: 600;
  }
`;

const CustomDropdown = styled.div`
  display: none;
  width: 85%;
  max-width: 350px;
  margin: 25px auto 15px auto;
  border-radius: 10px;
  background: rgba(161, 161, 177, 0.14);
  overflow: hidden;
  position: relative;
  font-family: 'Inter', sans-serif;
  
  box-shadow: 0 8px 20px 4px rgba(0,0,0,0.15);
  
  @media (max-width: 900px) {
    display: block;
  }
`;

const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  background: ${({ expanded }) => (expanded ? "transparent" : "#fff")};
  color: #2D0F29;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: ${({ expanded }) => (expanded ? "10px 10px 0 0" : "10px")};
  cursor: pointer;
  box-shadow: ${({ expanded }) => (expanded ? "none" : "0 2px 8px 0 rgba(60,60,90,0.07)")};
`;

const DropdownList = styled.div`
  display: ${({ expanded }) => (expanded ? "block" : "none")};
  background: rgba(161, 161, 177, 0.14);
  border-radius: 0 0 10px 10px;
  overflow: hidden;
`;

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background: ${({ selected }) => (selected ? "#fff" : "transparent")};
  color: ${({ selected }) => (selected ? "#2D0F29" : "#757285")};
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: ${({ selected }) => (selected ? "0 2px 8px 0 rgba(60,60,90,0.07)" : "none")};
  margin: 2px;
  border-radius: 10px;
  
  &:hover {
    background: #f5f5f6;
    color: #2D0F29;
  }
`;

const SelectionBarSectionComponent = () => {

    const [selectedCategory, setSelectedCategory] = useState(categories[0].key);
    const [dropdownExpanded, setDropdownExpanded] = useState(false);
    return (
        <SelectionBarSection>
            <SelectionBar>
                {categories.map(cat => (
                    <SelectionItem
                        key={cat.key}
                        selected={selectedCategory === cat.key}
                        onClick={() => setSelectedCategory(cat.key)}
                        aria-pressed={selectedCategory === cat.key}
                    >
                        <SelectionIcon
                            src={selectedCategory === cat.key ? cat.iconPink : cat.iconGrey}
                            alt={cat.label}
                            loading="lazy" 
                        />
                        {cat.label}
                    </SelectionItem>
                ))}
            </SelectionBar>
            <CustomDropdown>
                <DropdownHeader
                    expanded={dropdownExpanded}
                    onClick={() => setDropdownExpanded(!dropdownExpanded)}
                >
                    <SelectionIcon
                        src={categories.find(cat => cat.key === selectedCategory).iconPink}
                        alt={categories.find(cat => cat.key === selectedCategory).label}
                        loading="lazy" 
                    />
                    {categories.find(cat => cat.key === selectedCategory).label}
                </DropdownHeader>
                <DropdownList expanded={dropdownExpanded}>
                    {categories.map(cat => (
                        <DropdownItem
                            key={cat.key}
                            selected={selectedCategory === cat.key}
                            onClick={() => {
                                setSelectedCategory(cat.key);
                                setDropdownExpanded(false);
                            }}
                        >
                            <SelectionIcon
                                src={selectedCategory === cat.key ? cat.iconPink : cat.iconGrey}
                                alt={cat.label}
                                loading="lazy" 
                            />
                            {cat.label}
                        </DropdownItem>
                    ))}
                </DropdownList>
            </CustomDropdown>
            <PostsGrid>
                {postsByCategory[selectedCategory].map((post, idx) => (
                    <PostItem
                        key={idx}
                        href={`https://donotpay.com/learn/${post.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <PostImage src={post.image} alt={post.title} loading="lazy" />
                        <PostTitle>{post.title}</PostTitle>
                        <PostMeta>{post.date} • {post.read}</PostMeta>
                    </PostItem>
                ))}
            </PostsGrid>

            <PostsGridMobile>
                {postsByCategory[selectedCategory].slice(0, 3).map((post, idx) => (
                    <PostItem
                        key={idx}
                        href={`https://donotpay.com/learn/${post.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <PostImage src={post.image} alt={post.title} loading="lazy" />
                        <PostTitle>{post.title}</PostTitle>
                        <PostMeta>{post.date} • {post.read}</PostMeta>
                    </PostItem>
                ))}
            </PostsGridMobile>
        </SelectionBarSection>
    );
};

export default SelectionBarSectionComponent;